import { render, staticRenderFns } from "./Borrowings.vue?vue&type=template&id=66ad0ce6&"
import script from "./Borrowings.vue?vue&type=script&lang=js&"
export * from "./Borrowings.vue?vue&type=script&lang=js&"
import style0 from "./Borrowings.vue?vue&type=style&index=0&id=66ad0ce6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports